<template>
  <div id="app" :class="{'mobile-safari': isMobileSafari, 'general-safari': isSafari}">
    <app-header></app-header>
    <transition :name="transition" mode="out-in">
      <router-view :images="images" :transition="transition2"></router-view>
    </transition>
    <app-cover-image :pageOpen="pageOpen" v-if="drawComponent" :isApple="isApple"></app-cover-image>
    <app-circles :pageOpen="pageOpen" v-if="userHasNavigated"></app-circles>
    <img v-for="(image, index) in images" :key="index" style="display:none" :src="image">
  </div>
</template>

<script>
import Vue from "vue";
import CoverImage from "./components/CoverImage.vue";
import Circles from "./components/Circles.vue";
import Header from "./components/Header.vue";
import { eventBus } from "./main";
import { body } from "./main";
import { html } from "./main";
import { isMobileSafari } from "./main";
import { isSafari } from "./main";
const time = new Date().getHours();
var is_OSX = navigator.platform.match(/(Mac|iPhone|iPod|iPad)/i) ? true : false;
var is_iOS = navigator.platform.match(/(iPhone|iPod|iPad)/i) ? true : false;
export default {
  name: "app",
  data() {
    return {
      transition: "slide-fade",
      transition2: "fade",
      pageOpen: false,
      drawComponent: true,
      invertColors: false,
      navigated: false,
      themeDark: false,
      images: [],
      imagesLoaded: false,
      isMobileSafari: isMobileSafari,
      isSafari: isSafari,
      workItems: this.$store.state.globals.workItems
    };
  },
  computed: {
    userHasNavigated() {
      this.drawComponent;
      this.navigated;
      return this.drawComponent && this.navigated;
    },
    isApple() {
      return is_OSX || is_iOS ? true : false;
    }
  },
  methods: {
    bodyColorSwap() {
      body.classList.add("triggered");
      if (this.themeDark) {
        body.classList.remove("invert");
      } else {
        body.classList.add("invert");
      }
      this.themeDark = !this.themeDark;
    },
    openAboutWork() {
      body.classList.add("about-page-opened");
    },
    closeAboutWork() {
      body.classList.remove("about-page-opened");
    },
    reAnimate() {
      this.drawComponent = false;
      Vue.nextTick(() => {
        this.drawComponent = true;
      });
    },
    openPage() {
      this.navigated = true;
      if (!this.pageOpen) {
        this.pageOpen = true;
        this.reAnimate();
      }
    },
    closeAnimation() {
      if (this.pageOpen) {
        this.pageOpen = false;
        this.reAnimate();
      }
    },
    closePage() {
      if (this.pageOpen) {
        this.pageOpen = false;
        this.reAnimate();
        this.$router.push("/");
      }
    },
    pushPage(route, latency) {
      if (!this.pageOpen && window.innerWidth > window.innerHeight) {
        setTimeout(() => {
          this.$router.push(`/${route}`);
        }, latency);
      } else {
        this.$router.push(`/${route}`);
      }
    },
    goToWork() {
      this.pushPage("work", 222);
      this.openPage();
    },
    goToContact() {
      this.pushPage("contact", 333);
      this.openPage();
    },
    getImages() {
      this.workItems.map(item => {
        this.images.push(item.image.url);
      });
    }
  },
  components: {
    appCoverImage: CoverImage,
    appCircles: Circles,
    appHeader: Header
  },
   created() {
    this.getImages();
    if (isMobileSafari) {
      html.classList.add("mobile-safari");
    }
    if (time < 5 || time >= 21) {
      this.themeDark = true;
      body.classList.add("invert");
    } else {
      this.themeDark = false;
      body.classList.remove("invert");
    }
    if (this.$route.name != "home") {
      this.pageOpen = true;
      this.navigated = true;
    }
    eventBus.$on("getImages", this.getImages);
    eventBus.$on("goToWork", this.goToWork);
    eventBus.$on("goToContact", this.goToContact);
    eventBus.$on("closePage", this.closePage);
    eventBus.$on("pageIsOpen", this.openPage);
    eventBus.$on("pageIsClosed", this.closePage);
    eventBus.$on("swapTheme", this.bodyColorSwap);
    eventBus.$on("aboutWindowOpened", this.openAboutWork);
    eventBus.$on("aboutWindowClosed", this.closeAboutWork);
  }
};
</script>
